<template>
  <label
    :class="[
      'input-checkbox',
      mode,
      model && `input-checkbox__${model}`,
      { checked: reverse ? !value : value },
      { disabled: disabled }
    ]"
  >
    <div class="input-checkbox__slide-off">{{ toggleTexts[0] }}</div>
    <div class="input-checkbox__slide-on">{{ toggleTexts[1] }}</div>
    <input
      v-if="!Object.keys(this.$slots).length"
      ref="input"
      :value="value"
      :checked="value"
      :disabled="disabled"
      type="checkbox"
      @change="$emit('input', $event.target.checked)"
      @input="$emit('input', $event.target.checked)"
    >
    <slot v-else />
    <span v-if="label" class="input-checkbox__label t-body t-body__medium">{{
      label
    }}</span>
    <slot name="label" />
    <span class="check__mark"/>
  </label>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
    value: { type: [Boolean, Number, String], default: false },
    label: { type: String, default: "" },
    model: { type: String, default: "" },
    mode: { type: String, default: "" },
    reverse: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    toggleTexts: { type: Array, default: () => ["Uit", "Aan"] }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "../../util.scss";
.input-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
  input[type="checkbox"] {
    display: none;

    &:checked ~ .check__mark {
      border: 1px solid white;
      outline: 1px solid rgb(133, 194, 43);
      background-color: rgb(133, 194, 43);
    }
  }
  &.disabled {
    opacity: 0.4;
  }
  .check__mark {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    width: 16px;
    height: 16px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
    color: rgb(133, 194, 43);
    background-color: white;
    outline: 1px solid grey;
    will-change: auto;
  }
  &__label {
    margin-left: 24px;
    user-select: none;
  }

  &__slide {
    display: flex;
    .check__mark {
      display: none;
    }
    &-off,
    &-on {
      width: 56px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: grey;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      margin: 0;
      transition: 200ms ease-in-out all;
    }
    &.always-on {
      .input-checkbox__slide-off {
        background: rgb(133, 194, 43);
      }
    }
    &-off {
      content: "Uit";
      background: rgb(143, 143, 143);
      color: white;
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }
    &-on {
      content: "Aan";
      background: $grey-border;
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }
    &.checked {
      .input-checkbox__slide-on,
      .input-checkbox__slide-off {
        transition: 200ms ease-in-out all;
      }
      .input-checkbox__slide-on {
        background: rgb(133, 194, 43);
        color: white;
      }
      .input-checkbox__slide-off {
        background: $grey-border;
        color: black;
      }
    }
  }
}
</style>
